import { render, staticRenderFns } from "./anniversary.vue?vue&type=template&id=5035b604&scoped=true&"
import script from "./anniversary.vue?vue&type=script&lang=js&"
export * from "./anniversary.vue?vue&type=script&lang=js&"
import style0 from "./anniversary.vue?vue&type=style&index=0&id=5035b604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5035b604",
  null
  
)

export default component.exports